import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Form, message } from 'antd';
import { currencyData } from 'utils/constant';
import { surveyApis } from 'apis/operation/surveyApis';
import ToggleButton from 'components/button/ToggleButton';
import Message from 'components/etc/Message';
import UtcTimer from 'components/etc/UtcTimer';

import SmallModal from 'components/form/SmallModal';
import VerticalForm from 'components/form/DefaultForm';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultInput from 'components/input/DefaultInput';
import RangeDatePicker from 'components/input/RangeDatePicker';
import DefaultSelect from 'components/select/DefaultSelect';
import SubmitButton from 'components/button/SubmitButton';
import { useTranslation } from 'react-i18next';

const SurveyUpdateModal = ({ record, setVisible, visible, fetchData }) => {
  const { t } = useTranslation();
  const dateFormat = 'YYYY-MM-DD HH:mm:00';

  const today = dayjs().format(dateFormat);
  const [inputData, setInputData] = useState();
  const [answerList, setAnswerList] = useState(); //handleSubmit에 보내줘야함
  const [restrictedCounList, setRestrictedCounList] = useState(); //제한 국가

  //무제한 체크
  const handleCheckUnlimited = (e) => {
    if (e.target.checked === true) {
      setInputData({ ...inputData, end_date: '9999-12-31 23:59:59' });
    } else {
      setInputData({ ...inputData, end_date: today });
    }
  };
  const handleSelectChange = (e, p) => {
    setInputData({ ...inputData, [p.name]: e });
  };
  const handleInputChange = (e) => {
    let { name, value, checked } = e.target;
    if (name === 'exception_country') {
      // inputData.exception_country.replace(/ /g, '');
      setInputData({
        ...inputData,
        [name]: value.toUpperCase().replace(/ /g, ''),
      });
    } else if (name === 'is_public') {
      setInputData({ ...inputData, [name]: checked === true ? 1 : 0 });
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };
  //multi(제외국가)
  const handleMultiSelectChange = (e) => {
    setInputData({ ...inputData, exception_country: e });
  };

  const handleSubmit = async () => {
    const res = await surveyApis.surveyUpdate(record, inputData, answerList);
    if (!res) {
      return false;
    }
    fetchData();
    setVisible(false);
    message.success(
      `${record.survey_id}${t(
        'survey.surveyUpdateModal.submitSuccessMessage',
      )}`,
    );
  };
  const fetchInputData = async () => {
    const res = await surveyApis.surveyDetail(
      record.survey_id,
      record.question_id,
    );
    // 문자열 그대로 나타내면 ㄴㄴ multiple 로 뽑기위해서는 split해줘야한다.
    if (res.master[0]['exception_country'] !== '') {
      res.master[0]['exception_country'] =
        res.master[0].exception_country.split(',');
    }
    setInputData(res.master[0]);
    setAnswerList(res.question);
  };

  const fetchDropdown = async () => {
    const res = await surveyApis.restrictedCountry();
    res.map((v, i) => {
      v.key = v.country_code;
      v.value = v.country_code;

      v.text = v.country_name;
    });
    setRestrictedCounList(res);
  };
  useEffect(() => {
    fetchInputData().catch(console.log);
    fetchDropdown().catch(console.log);
    setInputData(record);
  }, [visible]);
  return (
    <SmallModal
      footer={
        <SubmitButton onClick={handleSubmit}>
          {t('survey.surveyUpdateModal.edit')}
        </SubmitButton>
      }
      title={t('survey.surveyUpdateModal.title')}
      visible={visible}
      onCancel={setVisible}
      fetchData={fetchData}
    >
      <VerticalForm>
        <Form.Item label={t('survey.surveyUpdateModal.surveyName')}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DefaultInput
              style={{ width: '10rem', marginRight: '2rem' }}
              value={inputData?.title}
              name='title'
              type='number'
              onChange={handleInputChange}
              placeholder={t('survey.surveyUpdateModal.multilingualID')}
            />
            <Message value={inputData?.title_text} width={'15rem'} />
          </div>
        </Form.Item>
        <Form.Item label={t('survey.surveyUpdateModal.surveyPeriod')}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <RangeDatePicker
              style={{ width: '25rem' }}
              showTime
              value={[
                dayjs(inputData?.start_date, dateFormat),
                dayjs(inputData?.end_date, dateFormat),
              ]}
            />
            <CheckboxOneType
              style={{ marginLeft: '1rem' }}
              onChange={handleCheckUnlimited}
              checked={
                inputData?.end_date.split('-')[0] === String(9999) && true
              }
            >
              {t('survey.surveyUpdateModal.unlimited')}
            </CheckboxOneType>
          </div>
          <UtcTimer
            onGrayBox={true}
            startDate={inputData?.start_date}
            endDate={inputData?.end_date}
          />
        </Form.Item>
        <Form.Item label={t('survey.surveyUpdateModal.itemReward')}>
          <div style={{ display: 'flex' }}>
            <DefaultSelect
              optionList={currencyData}
              style={{ marginRight: '1rem' }}
              placeholder={t('survey.surveyUpdateModal.itemRewardPlaceholder')}
              value={inputData?.currency}
              name='currency'
              onChange={handleSelectChange}
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <DefaultInput
                type='number'
                width={'10rem'}
                placeholder='0'
                value={inputData?.quantity}
                name='quantity'
                onChange={handleInputChange}
              />
              <p style={{ marginLeft: '.5rem' }}>
                {t('survey.surveyUpdateModal.items')}
              </p>
            </div>
          </div>
        </Form.Item>
        <Form.Item label={t('survey.surveyUpdateModal.countryRestriction')}>
          <DefaultSelect
            onChange={handleMultiSelectChange}
            mode='multiple'
            optionList={restrictedCounList}
            placeholder='제한 국가'
            name={t('survey.surveyUpdateModal.countryRestrictionPlaceholder')}
            value={
              // null로 해도 ''처리가 돼서 undefined줬습니다.
              inputData?.exception_country?.length === 0
                ? undefined
                : inputData?.exception_country
            }
          />
        </Form.Item>
        <Form.Item label={t('survey.surveyUpdateModal.publicStatus')}>
          <ToggleButton
            name='is_public'
            onChange={handleInputChange}
            value={inputData?.is_public}
            checked={inputData?.is_public === 1 ? true : false}
          />
        </Form.Item>
      </VerticalForm>
    </SmallModal>
  );
};
export default SurveyUpdateModal;
